import React, { useEffect, useRef } from "react";
import { Div, Text } from "../../Kit";
import { Button } from "../../Kit/Button";
import { useForm } from "react-hook-form";
import { useGetOtpCode } from "../../../Store/modules/auth/getOtpCode";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useLanguage } from "../../../Store/modules/language";
import { CountryCode } from "../../SharedComponents/CountryCode/CountryCode";
import { Trans, useTranslation } from "react-i18next";
import googleLogo from "../../Icons/google_login_icon.png";
import { useThemeColors } from "../../../Store/modules/theme";
import { useGoogleLogin } from "@react-oauth/google";
import { useAuthGoogle } from "../../../Store/modules/auth/authGoogle";
import { Pages } from "../../../Constants/pages";

export type LoginFormTypes = {
  username: string;
  country_code?: string;
};
const schema = yup.object({
  username: yup.string().required("شماره موبایل الزامی است."),
});
export const LoginForm: React.FC = () => {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<LoginFormTypes>({
    resolver: yupResolver(schema),
    mode: "onSubmit",
  });
  const { dispatchGetOtpCode, getOtpCodeLoading } = useGetOtpCode();
  const { dispatchAuthGoogle } = useAuthGoogle();
  const { direction } = useLanguage();
  const { t } = useTranslation();
  const [theme] = useThemeColors();

  const inputRef = useRef<HTMLInputElement | null>(null);
  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSubmit(onSubmit)();
    }
  };

  const login: () => void = useGoogleLogin({
    onSuccess: (credentialResponse) => {
      dispatchAuthGoogle({
        token: credentialResponse.access_token,
      });
    },
    onError: () => {
      console.log("Login Failed");
    },
    flow: "implicit",
  });

  const onSubmit = (data: LoginFormTypes) => {
    dispatchGetOtpCode(data);
  };

  return (
    <div className="px-[17px] mt-[18px] w-full">
      <Div
        className="flex justify-between rounded-[5px]"
        borderWidth="1px"
        dir="rtl"
        borderColor="optBorderInput"
        borderStyle="solid"
      >
        <Text elementType="div" className="px-3" translatable={false}>
          <input
            {...register("username")}
            className="h-[45px] ltr placeholder:text-sm outline-0 focus:outline-none rounded-[5px] w-full bg-transparent"
            ref={(e) => {
              register("username").ref(e);
              inputRef.current = e;
            }}
            dir="ltr"
            //@ts-ignore
            placeholder={t("login.loginForm.phoneNumber")}
            onKeyDown={handleKeyDown}
          />
        </Text>
        <CountryCode control={control} />
      </Div>

      <div dir={direction}>
        {errors.username?.message ? (
          <Text elementType="span" color="red" className="text-xs">
            {errors.username?.message}
          </Text>
        ) : null}
      </div>

      <Button
        title="login.loginForm.sendVerificationCode"
        bg="primary"
        onClick={handleSubmit(onSubmit)}
        loading={getOtpCodeLoading}
        className="w-full h-[45px] mt-5 bg-[#009AFD]"
      />
      <div className="flex items-center gap-3 my-4">
        <Div
          border
          className="flex-1"
          style={{ borderTopColor: theme["optBorderInput"], borderTopWidth: "1px" }}
        />
        <Text elementType="span" color="tertiary" className="select-none">
          یا
        </Text>
        <Div
          border
          className="flex-1"
          style={{ borderTopColor: theme["optBorderInput"], borderTopWidth: "1px" }}
        />
      </div>
      <div onClick={login}>
        <Div
          border
          className="h-[45px] w-full  mt-3 flex justify-center items-center rounded-[5px] pointer no-select"
        >
          <Text elementType="span" fontSize="13px" fontWeight={400}>
            login.signupLoginWith
          </Text>
          <img src={googleLogo} alt="Login with google" className="ms-2" width="20px" />
        </Div>
      </div>
      <div className="flex justify-center mt-[20px]">
        <div className="w-[248px] h-[1px] bg-[#E6EAEE]" />
      </div>
      <Text elementType="div" className="text-center mt-[14px]" fontSize={11} translatable={false}>
        <Trans
          i18nKey="login.loginForm.acceptTermsNotice"
          components={{
            Link: (
              <Text
                onClick={() =>
                  window.open(`https://lamtakam.com${Pages.TermsAndRegulations}`, "_blank")
                }
                elementType="span"
                className="underline"
                fontWeight={600}
                color="text"
              />
            ),
          }}
        />
      </Text>
    </div>
  );
};
